export const qkBaseFactorDefaults = ['factorDefaults']
